import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { forkJoin } from "rxjs";
import { map } from "rxjs/operators";
import { PermissionService } from "../services/permission.service";
import { BranchScopeService } from "../services/branch-scope.service";

export const permissionGuard: CanActivateFn = (_route, state) => {
  const permissions = inject(PermissionService);
  const branchScope = inject(BranchScopeService);
  const router = inject(Router);
  return forkJoin([permissions.ensure(), branchScope.ensure()]).pipe(
    map(() => {
      if (permissions.canReadUrl(state.url)) return true;
      const next = permissions.firstAllowedPath();
      const current = state.url.split("?")[0];
      if (next && next !== current) {
        void router.navigateByUrl(next);
      }
      return false;
    }),
  );
};
